import React from 'react';
import bellOffline from '../assets/bellOffline.svg';
import bellOnline from '../assets/bellOnline.svg';

const StatusIndicator = ({ status = 'unknown', admin = false, notifying = false }) => {
  const s = String(status).toLowerCase();
  const isOnline = s === 'online';

  const dotClass  = isOnline ? 'bg-green-500 animate-pulse' : 'bg-red-500';
  const textClass = isOnline ? 'text-green-600' : 'text-red-600';
  const label     = s.charAt(0).toUpperCase() + s.slice(1);

  const showBell = admin && notifying;

  return (
    <div className="flex items-center gap-2">
      {showBell ? (
        <img
          src={isOnline ? bellOnline : bellOffline}
          alt={isOnline ? 'Online notification bell' : 'Offline notification bell'}
          className={`w-4 h-4 ${isOnline ? 'animate-pulse' : ''}`}
          title={label}
        />
      ) : (
        <div className={`w-3 h-3 rounded-full ${dotClass}`} />
      )}
      <span className={`text-sm font-medium ${textClass}`}>{label}</span>
    </div>
  );
};

export default StatusIndicator;
